import { useMocks } from '../../shared/env';
import type { PayrollTaxesGateway } from './PayrollTaxesGateway';
import { HttpPayrollTaxesGateway } from './HttpPayrollTaxesGateway';
import { MockPayrollTaxesGateway } from './MockPayrollTaxesGateway';

export const payrollTaxesGateway: PayrollTaxesGateway = useMocks ? new MockPayrollTaxesGateway() : new HttpPayrollTaxesGateway();
export type { PayrollTaxesGateway } from './PayrollTaxesGateway';
